import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  connect() {
    if (!('standalone' in navigator) || !navigator.standalone) {
      return // Only enable pull-to-refresh for PWA mode
    }
    let touchStart = null
    let touchY = null

    this.element.addEventListener('touchstart', (e) => {
      // Only trigger if we're at the top of the page
      if (window.scrollY <= 0) {
        touchStart = e.touches[0].clientY
      }
    }, { passive: false })

    this.element.addEventListener('touchmove', (e) => {
      if (!touchStart) return

      touchY = e.touches[0].clientY
      const pulling = touchY - touchStart

      if (pulling > 0 && window.scrollY <= 0) {
        e.preventDefault()

        // Apply transform to show pulling effect
        const pullDistance = Math.min(pulling * 0.5, 100) // Limit max pull
        this.element.style.transform = `translateY(${pullDistance}px)`

        // Add visual feedback
        if (pulling > 70) {
          this.element.classList.add('pull-to-refresh-ready')
          this.element.classList.remove('pull-to-refresh-pulling')
        } else {
          this.element.classList.add('pull-to-refresh-pulling')
          this.element.classList.remove('pull-to-refresh-ready')
        }
      }
    }, { passive: false })

    this.element.addEventListener('touchend', () => {
      if (touchY && touchStart && (touchY - touchStart > 70)) {
        // Add transition for smooth reset
        this.element.style.transition = 'transform 0.2s ease-out'
        this.element.style.transform = ''
        setTimeout(() => window.location.reload(), 200)
      } else {
        // Just reset without reload
        this.element.style.transition = 'transform 0.2s ease-out'
        this.element.style.transform = ''
      }

      // Reset after transition
      setTimeout(() => {
        this.element.style.transition = ''
      }, 200)

      // Reset variables and classes
      touchStart = null
      touchY = null
      this.element.classList.remove('pull-to-refresh-ready')
      this.element.classList.remove('pull-to-refresh-pulling')
    })
  }
}
